import { render, staticRenderFns } from "./ResponsiveSplit.vue?vue&type=template&id=f07bbffe&"
import script from "./ResponsiveSplit.vue?vue&type=script&lang=js&"
export * from "./ResponsiveSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports